import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { theme } from 'styles/theme';

export const H1 = ({ children }: { children: ReactNode | string }) => {
	return (
		<h1
			css={css`
				font-size: 20px;
				line-height: 32px;
				font-weight: 400;
				color: ${theme.color.primary['400']};
				margin-bottom: 0;
			`}
		>
			{children}
		</h1>
	);
};
